import {
  Button,
  CircularProgress, Modal, TextField, makeStyles,
} from "@material-ui/core";
import { useContext, useEffect, useState } from "react";
import { axiosInstance, axiosParagonInstance } from "../../utilities/axios.config";
import mainContext from "../../context/main/mainContext";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    display: "block",
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    maxHeight: 500,
    overflow: "auto",
  },
  label: {
    fontSize: 18,
    display: "flex",
    alignItems: "center",
    padding: "10px 0",
  },
  searchContainer: {
    display: "flex",
    paddingTop: 10,
  },
  memberSection: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#f1f2f4",
    padding: 20,
    marginTop: 10,
  },
  fieldItem: {
    margin: "5px 0",
    wordBreak: "break-all",
  },
  premisesAttr: {
    display: "flex",
    flexDirection: "column",
    padding: "10px 0 0 10px",
  },
  showAllGroups: {
    color: "#007bff",
    cursor: "pointer",
    textDecoration: "underline",
  },
}));

function ViewMemberModal({
  open, onClose, memberData,
}) {
  const classes = useStyles();
  const { hrMappingConf } = useContext(mainContext);
  const [showAllGroups, setShowAllGroups] = useState(false);

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <div className={classes.root}>
        <h2 id="simple-modal-title">Name: {memberData.user?.displayName}</h2>
        <hr />
        <hr />
        <h5 style={{ marginBottom: 0 }}>User groups:</h5>
        {memberData.groups && <div>
          {memberData.groups.map(({ id, displayName }) => (
            <div style={{ margin: "0 0 5px 10px" }} key={id}>{displayName}</div>
          ))}
          {!memberData.groups?.length && <div style={{ marginLeft: 10 }}>User is not a member of any selected for sync group</div>}
        </div>}
        {memberData?.allGroups?.length > 0 && <h5 style={{ marginBottom: 0 }}>All Groups user belongs to: ({memberData.allGroups?.length || 0})&nbsp;&nbsp; <span className={classes.showAllGroups} onClick={() => setShowAllGroups(!showAllGroups)}>{showAllGroups ? "Hide all groups" : "Show all groups"}</span></h5>}
        {memberData?.allGroups && showAllGroups && <div>
          {memberData.allGroups.map(({ id, displayName }) => {
            const partOfSelectedForSync = memberData.groups.some((group) => group.id === id);
            if (partOfSelectedForSync) {
              return (
                <div style={{ margin: "0 0 5px 10px" }} key={id}>{displayName} <span style={{ color: "#007bff" }}>(Part of selected for sync group)</span></div>
              );
            }
            return <div style={{ margin: "0 0 5px 10px" }} key={id}>{displayName}</div>;
          })}
        </div>}
        <h5 style={{ marginBottom: 0 }}>User properties</h5>
        {memberData.user && <div className={classes.memberSection}>
          {Object.entries(memberData.user).map(([key, value]) => {
            if (!hrMappingConf.msMemberKeys.includes(key)) return null;
            if (typeof value === "string") {
              return (
                <div className={classes.fieldItem}>
                  <span style={{ color: "#905" }}>{key}</span>: <span style={{ color: "#690", marginLeft: 5 }}>{value}</span>
                </div>
              );
            }
            if (key === "onPremisesExtensionAttributes") {
              return (
                <>
                  <div className={classes.fieldItem}>
                    <span style={{ color: "#905" }}>{key}</span>:
                  </div>
                  <div className={classes.premisesAttr}>
                    {Object.entries(memberData.user[key]).map(([key, value]) => (
                      <div className={classes.fieldItem}>
                        <span style={{ color: "#905" }}>{key}</span>: <span style={{ color: "#690", marginLeft: 5 }}>{value || "null"}</span>
                      </div>
                    ))}
                  </div>
                </>
              );
            }
            return (
              <div className={classes.fieldItem}>
                <span style={{ color: "#905" }}>{key}</span>: <span style={{ color: "#690", marginLeft: 5 }}>{value?.toString() || <span style={{ color: "#808080" }}>null</span>}</span>
              </div>
            );
          })}
        </div>}
      </div>
    </Modal>
  );
}

export default ViewMemberModal;
